var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCoinsAlt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "\n\t\t\tCreated with Pixso.\n\t")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip4224_12336"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    fill: "white",
    fillOpacity: 0
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip4224_12336)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.5 32.5C15.59 32.5 10 29.7 10 26.25C10 22.79 15.59 20 22.5 20C29.4 20 35 22.79 35 26.25C35 29.7 29.4 32.5 22.5 32.5ZM26.25 11.02C28.27 8.93 32.55 7.5 37.5 7.5C44.4 7.5 50 10.29 50 13.75C50 16.06 47.48 18.08 43.75 19.16M50 25C50 26.89 47.37 28.53 43.5 29.38M50 13.75L50 35C50 36.85 47.48 38.46 43.75 39.33M35 26.25L35 36.25C35 39.7 29.4 42.5 22.5 42.5C15.59 42.5 10 39.7 10 36.25L10 26.25M35 36.25L35 46.25C35 49.7 29.4 52.5 22.5 52.5C15.59 52.5 10 49.7 10 46.25L10 36.25",
    stroke: "#718EBF",
    strokeOpacity: 1,
    strokeWidth: 4,
    strokeLinejoin: "round",
    strokeLinecap: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoinsAlt);
export default __webpack_public_path__ + "static/media/coins-alt.1f0038f556c5f1908a208eacaca59d28.svg";
export { ForwardRef as ReactComponent };